module.exports = __webpack_public_path__ + "static/img/aboutUs.a70c599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs.png
// module id = a4Aw
// module chunks = 1